<template>
  <div class="dialog-panel">
    <slot />
  </div>
</template>